import { render, staticRenderFns } from "./manually_ship_puzzle.vue?vue&type=template&id=4f042818&scoped=true&"
import script from "./manually_ship_puzzle.vue?vue&type=script&lang=js&"
export * from "./manually_ship_puzzle.vue?vue&type=script&lang=js&"
import style0 from "./manually_ship_puzzle.vue?vue&type=style&index=0&id=4f042818&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f042818",
  null
  
)

export default component.exports